module.exports = __webpack_public_path__ + "static/img/banner.fd7d61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/activity-page/banner.jpg
// module id = 71S7
// module chunks = 0